/// <amd-module name="Agile/Common/Components/AssetResolver/AssetResolver" />
import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";

export interface IAssetResolverProps {
    assets: string[];
    children: (resolvedAssets: string[]) => JSX.Element;
}
export class AssetResolver extends VssComponent<IAssetResolverProps> {
    public render(): JSX.Element {
        const resolvedAssets = this.props.assets.map(a => getAssetLocation(this.context.pageContext, a));
        return this.props.children(resolvedAssets);
    }
}
